import { Definitions } from "src/types/definitions";
import getWindow from "../helpers/window";
import { Definition } from "src/types/definition";
import "../types/global";

export const pushToDataLayerSitechromeWrapper = async (
  definitions: Definitions
): Promise<Definition[] | null> => {
  const { pushToDataLayer } = getWindow().asos?.siteChrome ?? {};

  if (pushToDataLayer) {
    return await pushToDataLayer(definitions);
  }

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(
        new Error(
          "Timeout: pushToDataLayer-ready event was not fired within 10 seconds"
        )
      );
    }, 10000);

    getWindow().asos?.eventBus?.once?.("pushToDataLayer-ready", async () => {
      clearTimeout(timeoutId);
      try {
        const result =
          await getWindow().asos?.siteChrome?.pushToDataLayer?.(definitions);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    });
  });
};
